import { cn } from "@fox1ck-org/ui";
import type { MetricDirection } from "@gen/tracker/v1/reporting_pb";

import { OutcomeCell, ProfitCell, ValueCell } from "@/components/campaigns/cells";
import type { Bag } from "@/lib/campaigns-table";
import { cellText, deltaText, deltaTone, type ReportColumn } from "./columns";

/** One number of the report: the list's cell for a built-in, the formula's own digits for a formula. */
export function MetricValue({ c, v, max, strong }: { c: ReportColumn; v: Bag; max: number; strong?: boolean }) {
  if (c.format === "outcome") return <OutcomeCell v={v} />;
  if (c.format === "profit") return <ProfitCell value={v.profit} max={max} strong={strong} />;
  if (c.custom) {
    return <span className={cn("font-mono text-sm tabular-nums", strong && "font-semibold")}>{cellText(c, v[c.key])}</span>;
  }
  return <ValueCell format={c.format} value={v[c.key]} dim={c.dim} strong={strong} />;
}

/** The change against the comparison period, inked by which way this metric is better. */
export function MetricDelta({ c, better, cur, prev, className }: { c: ReportColumn; better: MetricDirection; cur: number | undefined; prev: number | undefined; className?: string }) {
  const tone = deltaTone(better, cur, prev);
  return (
    <span className={cn("whitespace-nowrap font-mono text-xs tabular-nums", tone === "pos" ? "text-ok" : tone === "neg" ? "text-destructive" : "text-muted-foreground", className)}>
      {deltaText(c, cur, prev)}
    </span>
  );
}

/** «Только Δ»: the value with its change under it, small (доска Report). */
export function WithDelta({ children, delta, title }: { children: React.ReactNode; delta: React.ReactNode; title?: string }) {
  return (
    <span className="flex flex-col items-end leading-tight" title={title}>
      {children}
      {delta}
    </span>
  );
}
